import React, { useState } from "react";
import { Modal, Button } from "antd";
import { useDispatch } from "react-redux";
import { deleteTag } from "../../appRedux/actions/tags";

export default function DeleteTagModal({ info, visible, onCancel }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!info) return;
    try {
      setLoading(true);
      await dispatch(deleteTag(info._id || info.id));
      setLoading(false);
      if (onCancel) onCancel();
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Confirm Delete Tag"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="delete" type="primary" danger loading={loading} onClick={handleDelete}>
          Delete
        </Button>,
      ]}
      width={420}
    >
      <div className="text-center py-3">
        <i className="la la-exclamation-triangle text-danger mb-2" style={{ fontSize: "42px" }} />
        <p className="mb-1 fw-bold fs-5">Are you sure you want to delete this tag?</p>
        <p className="text-muted small">
          Tag: <strong>{info?.name}</strong> ({info?.code})
        </p>
      </div>
    </Modal>
  );
}
